import { motion } from "framer-motion";

const chapters = [
  { n: "01", title: "Build Freedom", body: "Own your territory and your time. An exclusive business built around a life lived on your own terms, off the grid and on the map." },
  { n: "02", title: "Build Wealth", body: "Multiple income streams — product sales, hospitality, and development revenue — in one of the fastest-growing industries in the country." },
  { n: "03", title: "Build Legacy", body: "Create destinations people travel to and communities that endure. A business worth passing down for generations." },
];

export const Manifesto = () => {
  return (
    <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-10">
      <div className="space-y-16 md:space-y-0">
        {chapters.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`manifesto-chapter-${c.n}`}
            className={`grid md:grid-cols-12 gap-6 md:gap-8 items-start py-12 md:py-16 border-t border-white/10 ${i % 2 ? "md:text-right" : ""}`}
          >
            <div className={`md:col-span-2 ${i % 2 ? "md:order-3 md:col-start-11" : ""}`}>
              <span className="font-serif-ed italic text-5xl md:text-6xl text-oed-gold">{c.n}</span>
            </div>
            <div className={`md:col-span-5 ${i % 2 ? "md:order-2 md:col-start-6" : "md:col-start-3"}`}>
              <h3 className="font-serif-ed italic text-4xl md:text-6xl leading-none">{c.title}</h3>
            </div>
            <div className={`md:col-span-4 ${i % 2 ? "md:order-1 md:col-start-1 md:text-left" : "md:col-start-9"}`}>
              <p className="text-base text-white/60 leading-relaxed">{c.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
